export default __webpack_public_path__ + "static/media/award-2.8174da26.png";